import React, { useMemo } from 'react';
import { TreeSelect } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import { resourceChildren } from '../../permissions/order';
import { canMoveResource } from '../../permissions/movement';

export function parentDirectoryTree(catalog, excludedResource) {
    const visited = new Set();
    const walk = (parent, path) => resourceChildren(catalog, parent).flatMap(item => {
        const node = catalog.resources[item.key];
        if (item.kind !== 'node' || node.kind !== 'directory' || item.key === excludedResource || visited.has(item.key)) return [];
        visited.add(item.key);
        const names = [...path, node.name];
        const pathLabel = names.join(' / ');
        return [{ key: item.key, value: item.key, title: node.name, pathLabel, searchValue: `${pathLabel} ${item.key}`,
            disabled: Boolean(excludedResource && !canMoveResource(catalog, excludedResource, item.key)),
            children: walk(item.key, names) }];
    });
    return [{ key: '', value: '', title: '根目录', pathLabel: '根目录', searchValue: '根目录', children: walk('', []) }];
}

const ParentDirectorySelect = React.forwardRef(function ParentDirectorySelect({ catalog, excludedResource, style, ...props }, ref) {
    const treeData = useMemo(() => {
        const decorate = nodes => nodes.map(node => ({ ...node, icon: <FolderOutlined />, title: <span title={node.pathLabel}>{node.title}</span>, children: decorate(node.children) }));
        return decorate(parentDirectoryTree(catalog, excludedResource));
    }, [catalog, excludedResource]);
    return <TreeSelect ref={ref} {...props} style={{ width: '100%', ...style }}
        treeData={treeData} treeDefaultExpandAll treeLine treeIcon showSearch
        treeNodeLabelProp="pathLabel" treeNodeFilterProp="searchValue"
        popupClassName="permission-parent-dropdown" listHeight={320} virtual={false}
        placeholder="选择父目录，可搜索名称或路径" />;
});
export default ParentDirectorySelect;
